import { stateValues } from 'util/states'
import * as Yup from 'yup'

const NewVisitLocationStateSchema = Yup.object().shape({
  location: Yup.string().label('Which state are you currently in?').oneOf(stateValues).required(),
})

export default NewVisitLocationStateSchema
